<template>
  <div class="original-message mb10">
    <thread-original-message v-if="showOriginalMessage" v-bind="originalMessage" :title="title"
                             :thread-id="threadId" />
    <message-unavailable v-else :id="originalMessage.id" :thread-id="threadId" :unavailable-reason="unavailableReason"
                         :restore-button-title="restoreButtonTitle" @restore="restoreOriginalMessage" />
  </div>
</template>

<script>
import MessageUnavailable from './message-unavailable'
import ThreadOriginalMessage from './thread-original-message'
import { mapActions } from 'vuex'

export default {
  components: { MessageUnavailable, ThreadOriginalMessage },
  props: {
    originalMessage: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    threadId: {
      type: Number,
      required: true
    }
  },
  computed: {
    restoreButtonTitle() {
      return this.i18n.t('member.forums.restore_post', {content: this.title})
    },

    showOriginalMessage() {
      // Only show the message if:
      // - It's not deleted
      // - It's not awaiting review, or if it is, it is still visible for the member because
      //   they are the author (in which case the content property is set)
      return !this.originalMessage.isDeleted && (!this.originalMessage.isPendingReview || this.originalMessage.content)
    },

    unavailableReason() {
      if (this.originalMessage.isDeleted) {
        // If the message id is missing, the record was physically deleted
        return this.originalMessage.id === null ? 'physically_deleted' : 'logically_deleted'
      } else if (this.originalMessage.isPendingReview) {
        return 'pending_review'
      } else {
        throw new Error('Message is unavailable for unknown reason')
      }
    }
  },
  methods: mapActions(['restoreOriginalMessage'])
}
</script>
